export const progressResultsSelector = state => state.UI.progressResults;

export const progressMeterSelector = state => state.UI.progressMeter;

export const progressTypeSelector = state => state.UI.progressType;

export const fullloaderSelector = state => state.UI.fullloader;

export const loaderMsgSelector = state => state.UI.loaderMsg;
